// PPECB wants the employee number of the PPECB inspector ON DUTY that day on every
// product-inspection submission. Ask before each send (Inspection + Dispatch), prefilled with
// the number last used on this device for this tenant. Asked BEFORE mutate(), like lateLoiAck:
// the save overlay's watchdog starts at mutate(). Remembered only AFTER the call succeeded.

import { promptDialog } from '@/components/Dialogs'

const keyFor = (tenantId: string) => `ppecb.inspectorOnDuty.${tenantId}`
const DIGITS = /^\d+$/

function lastUsed(tenantId: string): string | null {
  try {
    const v = localStorage.getItem(keyFor(tenantId))?.trim()
    return v && DIGITS.test(v) ? v : null
  } catch { return null }   // private window / blocked storage: no prefill, nothing breaks
}

/** Save the number after the PPECB call succeeded, so a refused send leaves nothing behind. */
export function rememberInspectorOnDuty(tenantId: string, code: string): void {
  try { localStorage.setItem(keyFor(tenantId), code.trim()) } catch { /* per-device convenience only */ }
}

/** Ask first. Returns digits, or null = cancelled: do NOT send. */
export async function askInspectorOnDuty(fallback: string | null, tenantId: string): Promise<string | null> {
  let note = ''
  let prefill = lastUsed(tenantId) ?? (fallback ?? '').trim()
  for (;;) {
    const answer = await promptDialog({
      title: 'Inspector on duty',
      message: `PPECB needs the employee number of the PPECB inspector on duty today.${note}`,
      placeholder: 'Employee number',
      confirm: 'Send to PPECB',
      defaultValue: prefill,
      inputMode: 'numeric',
    })
    if (answer === null) return null
    const code = answer.trim()
    if (DIGITS.test(code)) return code
    note = '\n\nUse digits only, for example 1885.'
    prefill = code
  }
}
